//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CFooter from "@/common/Footer"
export default{
	data(){
		return {

		}
	},
	mounted(){

	},
	methods:{

	},
	components: {
		CFooter
	}
}



// WEBPACK FOOTER //
// ./src/components/console/index.vue